export default "__VITE_ASSET__VSnvf9gM__"